module.exports = __webpack_public_path__ + "img/icoon_houtbewerking_small.d7a2cb53.svg";